var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.146581 6.8539L6.14677 12.8534C6.2441 12.9507 6.37213 13 6.50013 13C6.62814 13 6.75616 12.9514 6.8535 12.8534C7.04883 12.658 7.04883 12.3414 6.8535 12.1461L1.20663 6.49993L6.8535 0.853781C7.04883 0.658465 7.04883 0.341803 6.8535 0.146487C6.65816 -0.048829 6.34146 -0.048829 6.14612 0.146487L0.14593 6.14595C-0.0487431 6.34194 -0.048759 6.65858 0.146581 6.8539Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.271767b6.svg";
export { ForwardRef as ReactComponent };